export enum TransportationComponentErrorMessages {

    MESSAGE_START = 'start_not_entered',
    MESSAGE_DESTINATION = 'destination_not_entered',
    MESSAGE_LOCATION_EQUAL = 'equal_addresses',
    MESSAGE_DATE = 'check_if_your_date_picked_correctly',
}